/* ==========================================================================
   Cura — Featured Collection
   - Variant pills: exact variant resolution per option combination
   - Price / compare-at / discount %: re-rendered from the SELECTED variant only
   - Sold out: per-variant (disabled Sold Out button) and all-sold (locked card)
   - Quantity stepper (min 1)
   - AJAX add to cart → Dawn cart drawer / notification via renderContents
   - Carousel arrows (desktop) with disabled end states
   Vanilla JS. Editor-safe re-init.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* CARD                                                                */
  /* ------------------------------------------------------------------ */

  function initCard(card) {
    if (card.dataset.cfcInit === 'true') return;
    card.dataset.cfcInit = 'true';

    var dataEl = card.querySelector('[data-cfc-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('cura-fc-card: bad variant JSON', err);
      return;
    }

    var variants = data.variants || [];
    var allSold = card.dataset.allSold === 'true';

    var priceEl   = card.querySelector('[data-cfc-price]');
    var compareEl = card.querySelector('[data-cfc-compare]');
    var badgeEl   = card.querySelector('[data-cfc-badge]');
    var atcBtn    = card.querySelector('[data-cfc-atc]');
    var atcLabel  = card.querySelector('[data-cfc-atc-label]');
    var qtyInput  = card.querySelector('[data-cfc-qty-input]');
    var qtyMinus  = card.querySelector('[data-cfc-qty-minus]');
    var qtyPlus   = card.querySelector('[data-cfc-qty-plus]');
    var pills     = Array.from(card.querySelectorAll('[data-cfc-pill]'));

    /* ---- current selection state ---- */

    var selected = []; // option value per option index
    var currentVariant = null;

    // Initialise selection from the pre-selected pills (server-rendered)
    pills.forEach(function (pill) {
      if (pill.classList.contains('is-selected')) {
        selected[parseInt(pill.dataset.optionIndex, 10)] = pill.dataset.value;
      }
    });

    // Products without real variants have no pills — use the single variant
    if (pills.length === 0 && variants.length) {
      currentVariant = variants.find(function (v) { return v.id === data.currentId; }) || variants[0];
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.length === options.length &&
          v.options.every(function (val, i) { return val === options[i]; });
      }) || null;
    }

    if (!currentVariant) currentVariant = findVariant(selected);

    /* ---- render from the selected variant's OWN data ---- */

    function render() {
      var v = currentVariant;

      // Price
      if (priceEl) priceEl.textContent = v ? v.price : '';

      // Compare-at + discount % — ONLY when this exact variant has one
      var hasCompare = v && v.compare && v.pct > 0;
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        compareEl.textContent = hasCompare ? v.compare : '';
      }
      if (badgeEl) {
        badgeEl.hidden = !hasCompare;
        badgeEl.textContent = hasCompare ? v.pct + '% off' : '';
      }

      // ATC + qty availability
      var available = !!(v && v.available) && !allSold;
      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcLabel) {
          atcLabel.textContent = available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSold;
        }
      }
      if (qtyMinus) qtyMinus.disabled = !available || parseInt(qtyInput.value, 10) <= (parseInt(qtyInput.getAttribute('min'), 10) || 1);
      if (qtyPlus)  qtyPlus.disabled  = !available;
      if (qtyInput) qtyInput.disabled = !available;

      // Mark pills that lead to an unavailable variant (with current other picks)
      markUnavailablePills();
    }

    function markUnavailablePills() {
      pills.forEach(function (pill) {
        var idx = parseInt(pill.dataset.optionIndex, 10);
        var test = selected.slice();
        test[idx] = pill.dataset.value;
        var v = findVariant(test);
        pill.classList.toggle('is-oos', !v || !v.available);
      });
    }

    /* ---- pill clicks ---- */

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (allSold) return;
        var idx = parseInt(pill.dataset.optionIndex, 10);
        if (selected[idx] === pill.dataset.value) return;

        selected[idx] = pill.dataset.value;

        // Update selected style within this option row only
        var row = pill.closest('.cura-fcc__option-row');
        row.querySelectorAll('[data-cfc-pill]').forEach(function (p) {
          p.classList.toggle('is-selected', p === pill);
        });

        currentVariant = findVariant(selected);
        render();
      });
    });

    /* ---- quantity stepper ---- */

    function clampQty() {
      var floor = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < floor) n = floor;
      qtyInput.value = n;
      if (qtyMinus) qtyMinus.disabled = n <= floor || (currentVariant && !currentVariant.available);
      return n;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var floor = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      qtyInput.value = Math.max(floor, clampQty() - 1);
      clampQty();
    });

    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyInput.value = clampQty() + 1;
      clampQty();
    });

    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* ---- AJAX add to cart → Dawn cart drawer ---- */

    function getCartElement() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled || !currentVariant || !currentVariant.available) return;

        var qty = clampQty();
        var cart = getCartElement();

        atcBtn.classList.add('is-loading');
        if (atcLabel) atcLabel.textContent = atcBtn.dataset.labelAdding;

        var body = {
          items: [{ id: currentVariant.id, quantity: qty }]
        };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        if (addUrl.indexOf('.js') === -1) addUrl += '.js';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status && response.status !== 200) {
              throw new Error(response.description || 'Add to cart failed');
            }

            if (cart && typeof cart.renderContents === 'function') {
              // Dawn-native: refresh + open the drawer/notification
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(response);
            } else {
              // Fallback: update cart count bubble if possible, else go to cart
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }

            if (atcLabel) atcLabel.textContent = atcBtn.dataset.labelAdded;
            setTimeout(function () {
              if (atcLabel && !atcBtn.disabled) atcLabel.textContent = atcBtn.dataset.labelAdd;
            }, 1600);
          })
          .catch(function (err) {
            console.error('cura-fc-card ATC error:', err);
            if (atcLabel) atcLabel.textContent = atcBtn.dataset.labelAdd;
            window.alert(err.message || 'Could not add to cart. Please try again.');
          })
          .finally(function () {
            atcBtn.classList.remove('is-loading');
          });
      });
    }

    /* ---- first paint ---- */
    render();
  }

  /* ------------------------------------------------------------------ */
  /* CAROUSEL (arrows scroll one card; disabled at ends)                 */
  /* ------------------------------------------------------------------ */

  function initSection(root) {
    if (root.dataset.cfcSectionInit === 'true') return;
    root.dataset.cfcSectionInit = 'true';

    root.querySelectorAll('[data-cfc-card]').forEach(initCard);

    var track = root.querySelector('.cura-cfc__body--carousel [data-cfc-track]');
    var prevBtn = root.querySelector('[data-cfc-prev]');
    var nextBtn = root.querySelector('[data-cfc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function step() {
      var item = track.querySelector('.cura-cfc__item');
      if (!item) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    var t = null;
    track.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(updateArrows, 80);
    }, { passive: true });

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-cura-cfc]').forEach(initSection);
  }

    window.curaFCInitCards = function(scope) {
    (scope || document).querySelectorAll('[data-cfc-card]:not([data-cfc-init="true"])').forEach(function(c) {
      initCard(c);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cura-cfc]');
    if (root) {
      root.dataset.cfcSectionInit = 'false';
      root.querySelectorAll('[data-cfc-card]').forEach(function (c) { c.dataset.cfcInit = 'false'; });
      initSection(root);
    }
  });
})();